import { useSelector } from 'src/store';
import { OrganizationObject } from 'src/slices/organization';

/**
 * Hook to check if there is a default organization configured
 * @returns boolean indicating if any organization has isDefault: true
 */
export const useHasDefaultOrganization = (): boolean => {
  const organizations: OrganizationObject[] = useSelector((state) => state.organization.listOrganizations);

  return organizations.some((org) => org.isDefault === true);
};
